@if (!hideGamingCrossSellByArc) {
    <a class="banner-content ms-active-highlight" (click)="onBannerClick()">
        @if (showThemeIcon) {
            <span class="banner-theme-icon" [ngClass]="model.themeIcon"></span>
        } @else if (model.imageUrl) {
            <!-- we can not use image optimization with NgOptimized image as the dimension of the content is variable and not known -->
            <img class="banner-image" [src]="model.imageUrl" />
        }
        <div class="banner-info">
            <div class="banner-title">{{ model.title }}</div>
            <div class="banner-text">{{ model.text }}</div>
        </div>
        @if (showLearnMoreButton && model.link) {
            <button ds-button kind="tertiary" variant="outline" size="medium">{{ model.link.link }}</button>
        } @else {
            <span class="banner-theme-right"><vn-icon name="theme-right" size="13" /></span>
        }
    </a>
}
